<template>
  <card
    v-if="group"
    :image="cardImageUrl"
    :key="`${group.Id}/${group.OrganizationId}`"
  >
    <template v-slot:image-content>
      <span class="card__image-content">{{ group.Name }}</span> +
    </template>

    <template v-slot:header>{{ group.FormTitle }}</template>
    <template v-slot:text>
      <template v-if="myStudyTasksTodoNow.length === 0">
        {{ $t('generic.youHaveNothingToFillInAtTheMoment') }}
      </template>
      <template v-for="studyTask in myStudyTasksTodoNow" :key="studyTask.Id">
        <p>
          {{ studyTask.CardText }}<br />
          {{
            $tc('views.start.finishTheTaskLatest', {
              date: studyTask
                .getDeadline(group.PatientJoinedDate)
                .format('YYYY-MM-DD')
            })
          }}
        </p>
        <div class="center">
          <s-button @click="goToAction(studyTask)" class="button--blue">
            {{ getButtonLabel(studyTask) }}
          </s-button>
        </div>
      </template>
    </template>
  </card>
</template>

<script>
import { STUDY_TASK_ACTION_TYPES } from '@/constants';
import { mapActions, mapGetters } from 'vuex';
import {
  CURRENT_USER_ACTIONS,
  CURRENT_USER_GETTERS
} from '@/store/modules/currentuser';
import {
  STUDY_TASK_ACTIONS,
  STUDY_TASK_GETTERS
} from '@/store/modules/studytasks';

export default {
  components: {},
  props: {
    group: {
      required: true
    },
    showSymptomsReportButton: {
      required: false,
      default: true
    }
  },
  data() {
    return {
      cardImageUrl: '/images/groups/default.png'
    };
  },
  mounted() {
    this.checkImageExists(this.groupImageUrl, exists => {
      if (exists) {
        this.cardImageUrl = this.groupImageUrl;
      }
    });
  },
  methods: {
    ...mapActions('currentuser', {
      $setActiveGroup: CURRENT_USER_ACTIONS.SET_ACTIVE_GROUP
    }),
    ...mapActions('studytasks', {
      $setActiveStudyTask: STUDY_TASK_ACTIONS.SET_ACTIVE_STUDY_TASK
    }),
    async setGroupIfNotAlreadySet(group) {
      if (
        this.$activeGroup.Id !== group.Id &&
        this.$activeGroup.OrganizationId !== group.OrganizationId
      ) {
        const role = 'pat';
        await this.$setActiveGroup({ group, role });
      }
    },
    reportSymptoms(group) {
      this.setGroupIfNotAlreadySet(group);
      this.$router.push({ name: 'symptomReport' });
    },
    reportProm(promId) {
      this.$router.push({
        name: 'promReportEdit',
        params: { promid: promId }
      });
    },
    checkImageExists(url, callback) {
      const img = new Image();
      img.onload = () => callback(true); // Image exists
      img.onerror = () => callback(false); // Image does not exist
      img.src = url; // Trigger the loading of the image
    },
    goToAction(studyTask) {
      this.$setActiveStudyTask(studyTask);
      this.$router.push(studyTask.actionRoute);
    },
    getButtonLabel(studyTask) {
      switch (studyTask.Action) {
        case STUDY_TASK_ACTION_TYPES.PROM:
          return this.$t('generic.fillInSurvey');
        case STUDY_TASK_ACTION_TYPES.SYMPTOMS:
          return this.$t('generic.reportSymptoms');
        case STUDY_TASK_ACTION_TYPES.FILE_UPLOAD:
          return this.$t('generic.uploadFile');
      }
    }
  },
  computed: {
    ...mapGetters('currentuser', {
      $activeGroup: CURRENT_USER_GETTERS.ACTIVE_GROUP
    }),
    ...mapGetters('studytasks', {
      $myStudyTasksTodoNow: STUDY_TASK_GETTERS.MY_STUDY_TASKS_TODO_NOW_BY_GROUP
    }),
    myStudyTasksTodoNow() {
      return this.$myStudyTasksTodoNow(
        this.group.OrganizationId,
        this.group.Id,
        this.group.PatientJoinedDate
      );
    },
    groupImageUrl() {
      const orgId = this.group.OrganizationId.toLowerCase().replace(' ', '');
      const groupId = this.group.Id.toLowerCase().replace(' ', '');
      return `/images/groups/${orgId}_${groupId}.jpg`;
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  &__image-content {
    position: relative;
    top: -50px;
    font-weight: bold;
    color: #000;
  }
}
</style>
